// ponytail: shown only when api/statistics/live fails, so the tab keeps its shape (with a Dummy badge).
import { LiveStatistics } from '@/services/statistics';

const minutesAgo = (m: number) => new Date(Date.now() - m * 60_000).toISOString();

export const dummyLiveStatistics: LiveStatistics = {
    activeNow: 23,
    activeLast24Hours: 412,
    activeUsersPerHour: [4, 2, 1, 1, 0, 2, 9, 31, 58, 64, 52, 47, 41, 55, 60, 49, 38, 22, 15, 18, 21, 12, 8, 23],
    totalUsers: 48_213,
    newUsersToday: 37,
    newUsersLast7Days: 286,
    totalProjects: 1_284,
    newProjectsLast30Days: 14,
    latestUsers: [
        { id: 1, name: 'Ingrid Hansen', detail: 'ingrid.hansen@example.com', at: minutesAgo(6) },
        { id: 2, name: 'Erik Lund', detail: 'erik.lund@example.com', at: minutesAgo(19) },
        { id: 3, name: 'Sara Nilsson', detail: 'sara@example.com', at: minutesAgo(44) },
        { id: 4, name: 'Ola Berg', detail: 'ola.berg@example.com', at: minutesAgo(130) },
        { id: 5, name: 'Maja Johansson', detail: 'maja.j@example.com', at: minutesAgo(260) },
    ],
    recentlyActive: [
        { id: 6, name: 'Kari Nordmann', detail: 'kari@example.com', at: minutesAgo(0) },
        { id: 7, name: 'Lars Eriksen', detail: 'lars@example.com', at: minutesAgo(1) },
        { id: 1, name: 'Ingrid Hansen', detail: 'ingrid.hansen@example.com', at: minutesAgo(3) },
        { id: 8, name: 'Anna Svensson', detail: 'anna@example.com', at: minutesAgo(7) },
        { id: 9, name: 'Jonas Dahl', detail: 'jonas@example.com', at: minutesAgo(12) },
        { id: 10, name: 'Nora Bakke', detail: 'nora@example.com', at: minutesAgo(28) },
    ],
    latestProjects: [
        { id: 1, name: 'Fjordbyen Hus B', detail: 'Example Bolig AS', at: minutesAgo(90) },
        { id: 2, name: 'Sjøkanten 2', detail: 'Demo Utvikling', at: minutesAgo(60 * 26) },
        { id: 3, name: 'Parkhagen trinn 3', detail: 'Example Bolig AS', at: minutesAgo(60 * 72) },
        { id: 4, name: 'Strandvägen 12', detail: 'Demo Bygg AB', at: minutesAgo(60 * 140) },
    ],
    latestProfiles: [
        { id: 1, name: 'Demo Bygg AB', detail: null, at: minutesAgo(60 * 50) },
        { id: 2, name: 'Example Entreprenør AS', detail: null, at: minutesAgo(60 * 200) },
    ],
};
